<template>
    <div>
        <b-modal 
            v-model="mostrarModal" 
            :no-close-on-backdrop="true"
            @close="fecharAnexoForm()"
            :hide-header-close="true"
            :no-close-on-esc="true"
        >
            <div slot="modal-title">
                Anexo -
                <b-badge variant="warning">{{ acao }}</b-badge>
            </div>
            <app-erros-box
                :erros="erros"
                v-if="erros.length > 0"
            ></app-erros-box>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label class="required">Tipo do Anexo</label>
                        <b-form-select
                            :plain="true"
                            :options="tiposAnexos"
                            v-model="anexoTipoId"
                            text-field="descricao"
                            value-field="anexoTipoId"
                        ></b-form-select>
                        <b-alert show v-if="tipo && tipo.ajuda">{{
                            tipo.ajuda
                        }}</b-alert>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label class="required">Descricao</label>
                        <b-form-textarea
                            v-model="descricao"
                            :rows="3"
                            @input="
                                $v.descricao.$touch()
                            "
                            :state="
                                $v.descricao.$error
                                    ? false
                                    : null
                            "
                        ></b-form-textarea>
                        <b-form-invalid-feedback
                            >A descrição é obrigatório
                        </b-form-invalid-feedback>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row v-if="acao == 'INSERIR'">
                <b-col sm="12">
                    <b-form-group>
                        <label class='required'>Arquivo</label>
                        <b-form-file
                            v-model="arquivo"
                            :state="Boolean(arquivo)"
                            placeholder="Selecione o arquivo..."
                            ref="arquivoInput"
                            browse-text="Selecionar"
                        ></b-form-file>
                    </b-form-group>
                </b-col>
            </b-row>
            <div slot="modal-footer">
                <b-button
                    variant="secondary"
                    @click.stop="fecharAnexoForm()"
                    class="mr-2"
                    >Cancelar</b-button
                >
                <b-button
                    variant="primary"
                    :disabled="$v.$invalid"
                    @click.stop="confirmarSalvar()"
                    >Salvar</b-button
                >
            </div>
        </b-modal>
    </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'

export default {
    props: {
        mostrarModal: {
            type: Boolean,
            default: () => false
        },

        acao: {
            type: String
        },

        tiposAnexos: {
            type: Array
        },

        anexoAtualizar: {
            type: Object
        }
    },

    data() {
        return {
            erros: [],
            anexoTipoId: null,
            descricao: null,
            arquivo: null
        }
    },

    methods: {
        fecharAnexoForm() {
            this.resetAnexoForm()
            this.$emit('fechar')
        },

        resetAnexoForm() {
            this.descricao = null
            this.anexoTipoId = null
            this.arquivo = null
            this.erros = []
            this.$nextTick(() => {
                this.$v.$reset()
            })
        },

        preencherForm() {
            this.descricao = this.anexoAtualizar.descricao
            this.anexoTipoId = this.anexoAtualizar.anexoTipo.anexoTipoId
        },

        confirmarSalvar() {
            this.$swal({
                title: 'Anexo',
                html: `Confirma a ${this.acao == 'INSERIR' ? 'inserção' : 'atualização'} do anexos?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.salvarAnexo()
                }
            })
        },

        salvarAnexo() {
            let anexoDto = {
                anexoTipoId: this.anexoTipoId,
                descricao: this.descricao,
                arquivo: this.arquivo  
            }

            if (this.acao == 'INSERIR') {
                this.$emit('inserir', anexoDto)
            } else {
                anexoDto.despesaAnexoId = this.anexoAtualizar.despesaAnexoId
                this.$emit('atualizar', anexoDto)
            }
            this.fecharAnexoForm()
        },

    },

    watch: {
        anexoAtualizar() {
            if (this.mostrarModal 
                && this.acao == 'ATUALIZAR' 
                && this.anexoAtualizar != null) 
            {
                this.preencherForm()
            } 
        }
    },

    computed: {
        tipo() {
            let tiposTemp = this.tiposAnexos.find(
                (p) => p.anexoTipoId == this.anexoTipoId
            )
            return tiposTemp ? tiposTemp : {}
        }
    },

    validations: {
        anexoTipoId: {
            required
        },
        arquivo: {
            obrigatorio() {
                if (this.acao == 'INSERIR') {
                    return this.arquivo != null
                }
                return true
            }
        },
        descricao: {
            required
        },
    }   
}
</script>
